import './GlobalStyles.scss';

function GlobalStyles({ children }) {
    return children; // children = <App />
}

export default GlobalStyles;